<template>
  <svg class="icon"
       width="18"
       height="16"
       viewBox="0 0 18 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M3.69302 4.74609H0V15.6274H3.69302V4.74609ZM2.43998 11.8677H1.25304V10.813H2.43998V11.8677ZM2.43998 9.4938H1.25304V8.43912H2.43998V9.4938ZM1.25304 7.11995V6.06526H2.43998V7.11995H1.25304Z" />
    <path fill="currentColor" d="M14.3069 15.6274H18V4.74609H14.3069V15.6274ZM15.56 6.06526H16.7469V7.11995H15.56V6.06526ZM15.56 8.43912H16.7469V9.4938H15.56V8.43912ZM16.7469 10.813V11.8677H15.56V10.813H16.7469Z" />
    <path fill="currentColor" d="M7.15344 14.2422H8.47261V15.6281H7.15344V14.2422Z" />
    <path fill="currentColor" d="M9.52734 14.2422H10.8465V15.6281H9.52734V14.2422Z" />
    <path fill="currentColor" d="M4.74774 15.6295H6.09883V13.1889H11.9012V15.6295H13.2523V0H4.74774V15.6295ZM9.5935 11.8697H8.40656V10.815H9.5935V11.8697ZM9.5935 9.49588H8.40656V8.44119H9.5935V9.49588ZM9.5935 7.12202H8.40656V6.06734H9.5935V7.12202ZM11.9673 11.8697H10.7804V10.815H11.9673V11.8697ZM11.9673 9.49588H10.7804V8.44119H11.9673V9.49588ZM11.9673 7.12202H10.7804V6.06734H11.9673V7.12202ZM7.21965 2.50798H8.47269V1.25494H9.52737V2.50798H10.7804V3.56266H9.52737V4.81574H8.47269V3.56266H7.21965V2.50798ZM6.0327 6.06734H7.21965V7.12202H6.0327V6.06734ZM6.0327 8.44119H7.21965V9.49588H6.0327V8.44119ZM6.0327 10.815H7.21965V11.8697H6.0327V10.815Z" />
  </svg>
</template>

<script>
export default {
  name: 'Clinic',
};
</script>
